import React, {ReactElement} from 'react';
import mergeClasses from "../../../utils/merge-classes.ts";
import {BTN_BASE, BTN_SIZES, BTN_VARIANTS, ButtonSize, ButtonVariant} from "../button-const.ts";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    
    type?: 'button' | 'submit' | 'reset';
}

const Button = ({variant = 'primary', size = 'sm', type = 'button', className, ...props}: ButtonProps): ReactElement => (
    <button
        className={mergeClasses(BTN_BASE, BTN_VARIANTS[variant], BTN_SIZES[size], className)}
        type={type}
        {...props}
    />
);

export default Button;